
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/amanaki-thao-dien/discover",
      function () {
        return require("private-next-pages/[locale]/amanaki-thao-dien/discover/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/amanaki-thao-dien/discover"])
      });
    }
  